import * as React from 'react';

import MoneyMapGoWorkflow from '../../../../roadmap/components/go/MoneyMapGoWorkflow';

export default function GoMoneyMap() {
    return <MoneyMapGoWorkflow />;
}
